import ConfigService from "../config/Config.service";
import {
  SurveyService as ISurveyService,
  QuestionnaireResponse,
  SurveyResponse,
  VerifyPINRequest,
  VerifyPINResponse,
} from "../interfaces";

export default class SurveyService
  extends ConfigService
  implements ISurveyService
{
  getQuestionnaire(
    surveyGuid: string,
    respondentGuid?: string,
  ): Promise<QuestionnaireResponse> {
    let getUrl = this.makeUrl(
      `/Survey/Questionnaire?surveyGuid=${surveyGuid}&injectVisibility=true`,
    );
    if (respondentGuid) {
      getUrl += `&respondentGuid=${respondentGuid}`;
    }
    return this.get(getUrl);
  }

  submitResponse(response: SurveyResponse): Promise<void> {
    const postUrl = this.makeUrl("/Response");
    return this.post(postUrl, response);
  }

  verifyPIN(request: VerifyPINRequest): Promise<VerifyPINResponse> {
    const postUrl = this.makeUrl("/Survey/VerifyPIN");
    return this.postJson(postUrl, request);
  }
}
